import { createAdminApi } from "./api-client.js";
import type { AdminApi, AdminApiError } from "./api-client.js";
import { createTokenStorage } from "./token-storage.js";
import type { TokenStorage } from "./token-storage.js";

/**
 * 后台唯一的接口实例。
 *
 * 令牌读写集中在这里，界面层不碰存储；会话失效统一交给注册进来的处理器
 * （由 main.ts 接上路由跳转），这一层因此不认识路由，也不会与路由相互引用。
 */

export const API_BASE_URL = "/api/v1";

let tokenStorage: TokenStorage = createTokenStorage(window.localStorage);
let unauthorizedHandler: ((error: AdminApiError) => void) | null = null;

export function setUnauthorizedHandler(handler: (error: AdminApiError) => void): void {
  unauthorizedHandler = handler;
}

/** 测试用：换成内存存储，避免依赖浏览器环境。 */
export function useTokenStorage(storage: TokenStorage): void {
  tokenStorage = storage;
}

export const adminApi: AdminApi = createAdminApi({
  baseUrl: API_BASE_URL,
  getToken: () => tokenStorage.read(),
  onUnauthorized: (error) => {
    // 令牌已经无效，先清掉本地副本，避免后续请求继续带着废令牌。
    tokenStorage.clear();
    unauthorizedHandler?.(error);
  },
});

export function saveToken(token: string): boolean {
  return tokenStorage.write(token);
}

export function clearToken(): void {
  tokenStorage.clear();
}

export function currentToken(): string | null {
  return tokenStorage.read();
}
